import { useTenantData } from "contexts/tenant";

export const useMixGrouping = () => {
  const tenantData = useTenantData();
  return tenantData.mix_grouping;
};
